"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRegionFAQ = exports.upsertRegionFAQ = exports.deleteRegionFAQ = exports.getRegionFAQ = exports.addRegionFAQ = exports.getRegionFAQs = void 0;
const _ = require("lodash");
const getRegionFAQs = async (supabase, id) => {
    const { data, error } = await supabase
        .from("region_faq")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("region_id", id)
        .order("order", { ascending: true });
    if (!error) {
        return data;
    }
    return [];
};
exports.getRegionFAQs = getRegionFAQs;
const addRegionFAQ = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const faqs = await (0, exports.getRegionFAQs)(supabase, obj.region_id);
    const count = faqs.length + 1;
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    obj.order = count;
    const { data, error } = await supabase.from("region_faq").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addRegionFAQ = addRegionFAQ;
const getRegionFAQ = async (supabase, id) => {
    const { data, error } = await supabase
        .from("region_faq")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getRegionFAQ = getRegionFAQ;
const deleteRegionFAQ = async (supabase, id) => {
    const { error } = await supabase.from("region_faq").delete().eq("id", id);
    return error;
};
exports.deleteRegionFAQ = deleteRegionFAQ;
const upsertRegionFAQ = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("region_faq")
        .upsert(obj)
        .select();
    if (!error)
        return data;
    return error;
};
exports.upsertRegionFAQ = upsertRegionFAQ;
const updateRegionFAQ = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("region_faq")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateRegionFAQ = updateRegionFAQ;
